import React from 'react'
import styled from '@emotion/styled'
import { BasicCrossSell, Container } from 'components/layout'
import { FionaProducts, PAGE_BREAKPOINTS } from 'parameters/index'
import { Partner } from 'services/ContentfulService/models/partner/partner'
import { RichText } from 'components/vendor/Contentful/richText/RichTextRenderer'
import ContentfulImage from 'experiences/shared/ContentfulImage'
import { Split } from 'components/layout/primitives'
import { GoTo } from 'ui/inputs/GoTo'
import { AdvertiserDisclosure } from 'components/content'

interface Props {
	partner: Partner
}

export const PartnerDetailPage = ({ partner }: Props): JSX.Element => {
	const product = partner?.products && partner.products[0].name

	const getCrossSellProduct = (): FionaProducts | undefined => {
		switch (product) {
			case 'Life Insurance':
				return FionaProducts.LifeInsurance
			case 'Credit Cards':
				return FionaProducts.CreditCards
			case 'Personal Loan':
				return FionaProducts.Loans
			case 'Savings':
				return FionaProducts.Savings
			case 'Student Loan Refinance':
				return FionaProducts.StudentLoanRefinance
			case 'Mortgage':
				return FionaProducts.Mortgages
		}

		return undefined
	}
	const xsell = getCrossSellProduct()
	return (
		<Wrapper>
			<Container>
				<InnerContainer>
					<Split>
						<GoTo direction="left" href={'/learn/partners'}>
							Lenders and Partners
						</GoTo>
						<AdvertiserDisclosure />
					</Split>
					<HeaderContainer>
						<h1 style={{ paddingBottom: '1rem' }}>{partner.name}</h1>
						<ImageContainer>
							<ContentfulImage asset={partner.logo} width={128} layout="intrinsic" placeholder={true} />
						</ImageContainer>
					</HeaderContainer>
					{partner.description && <RichText document={partner.description} />}
					{xsell && <BasicCrossSell product={xsell} />}
					<MoreDetails style={{ marginTop: '24px' }}>
						<div>
							<h2>Connect with {partner.name}</h2>
							<p style={{ maxWidth: '400px', marginTop: '16px' }}>
								Learn more about {partner.productName || partner.name}, including how to get started today!
							</p>
						</div>
						<a href={partner.website} target="_blank" rel="noopener noreferrer nofollow">
							Visit {partner.name}&apos;s website
						</a>
					</MoreDetails>
				</InnerContainer>
			</Container>
		</Wrapper>
	)
}

const Wrapper = styled.div`
	padding-top: 16px;
	padding-bottom: 122px;
`

const InnerContainer = styled.div`
	max-width: 746px;
`

const MoreDetails = styled.div`
	max-width: 968px;
	width: 100%;
	padding: 32px;
	border-radius: 8px;
	box-shadow: 0 0 20px 0 rgba(69, 69, 69, 0.16);
	background-color: #ffffff;
	display: flex;
	align-items: center;
	justify-content: space-between;

	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		width: 100%;
		flex-direction: column;
		align-items: flex-start;

		a {
			margin-top: 24px;
			width: 100%;
		}
	}
`

const HeaderContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 2rem 0;

	@media only screen and (${PAGE_BREAKPOINTS.MOBILE}) {
		flex-direction: column;
		align-items: flex-start;
	}
`

const ImageContainer = styled.div`
	width: 120px;
	height: 68px;
	display: flex;
	align-items: center;
	justify-content: center;

	@media only screen and (${PAGE_BREAKPOINTS.MOBILE}) {
		margin-top: 16px;
	}
`
